<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row v-if="isMy" style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="onAddSave" v-acl="RMC_PROT_AUDITOR_SAVE" v-if="rmcProteinAuditorId==='0'&&(!detailForm.auditStatus||detailForm.auditStatus==='Draft')">保存</el-button>
        <!-- <el-button size="mini" class="btn" type="primary" @click="onEditSave" v-acl="RMC_PROT_AUDITOR_SAVE" v-if="rmcProteinAuditorId!=='0'&&(!detailForm.auditStatus||detailForm.auditStatus==='Draft')">保存</el-button> -->
        <el-button size="mini" class="btn" type="primary" @click="onEditSave" v-if="isShowEditSave" v-acl="RMC_PROT_AUDITOR_SAVE">保存</el-button>
        <!-- <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-acl="RMC_PROT_AUDITOR_APPROVE" v-if="detailForm.auditStatus!=='PendingApproval'">提交</el-button> -->
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-if="isShowSub" v-acl="RMC_PROT_AUDITOR_SUBMIT">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onApprove" v-acl="RMC_PROT_AUDITOR_APPROVE" v-if="detailForm.auditStatus==='PendingApproval'&&ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS')!==-1">批准</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onReturn" v-acl="RMC_PROT_AUDITOR_APPROVE" v-if="detailForm.auditStatus==='PendingApproval'&&ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS')!==-1">退回</el-button>
      </el-row>
      <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="140px">
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">审核员清单</p>
          </div>
          <div class="form_box">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="Category3" prop="category3Code" :rules="rules.category3Code">
                  <el-select v-model="detailForm.category3Code" :disabled="isDisabled||isForbidden" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in category3CodeOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Sponsor" prop="sponsorName">
                  <el-input v-model="detailForm.sponsorName" readonly placeholder="从供应商集团选择">
                    <el-button @click="onFacility" slot="append" icon="el-icon-search" :disabled="isSponsor||isForbidden"></el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核范围" prop="auditScope" :rules="rules.auditScope" class="is-required">
                  <el-select v-model="detailForm.auditScope" clearable multiple :disabled="isForbidden" placeholder="请选择" style="width:100%" class="multiple_sel">
                    <el-option :key="index" v-for="(item,index) in auditScopeOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="ASL Group" prop="aslGroupCode" :rules="rules.aslGroupCode" :class="(isSponsor&&!(detailForm.auditorType.length === 1 &&detailForm.auditorType[0] === 'SecondParty'))?'is-required':''">
                  <el-select v-model="detailForm.aslGroupCode" clearable :disabled="isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in aslGroupCodeOptions" :label="item.aslGroupName" :value="item.aslGroupCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="内审员" prop="auditorName" :rules="rules.auditorName" class="is-required">
                  <el-input v-model="detailForm.auditorName" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="性别" prop="auditorGender" :rules="rules.auditorGender" class="is-required">
                  <el-select v-model="detailForm.auditorGender" clearable :disabled="isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in sexOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="学历" prop="auditorEducation" :rules="rules.auditorEducation" class="is-required">
                  <el-select v-model="detailForm.auditorEducation" clearable :disabled="isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in educationOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="专业" prop="auditorMajor" :rules="rules.auditorMajor" class="is-required">
                  <el-input v-model="detailForm.auditorMajor" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="从业年限(养殖/食品)" prop="workYear" :rules="rules.workYear" class="is-required">
                  <el-input v-model="detailForm.workYear" :disabled="isForbidden" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="一方/二方/三方审核员" prop="auditorType" :rules="rules.auditorType" class="is-required">
                  <el-select v-model="detailForm.auditorType" clearable multiple :disabled="isForbidden" placeholder="请选择" style="width:100%" class="multiple_sel">
                    <el-option :key="index" v-for="(item,index) in auditorTypeOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核员状态" prop="auditorStatus" :rules="rules.auditorStatus" class="is-required">
                  <el-select v-model="detailForm.auditorStatus" :disabled="isForbidden||(detailForm.auditStatus!=='Approved'&&detailForm.auditStatus!=='Returned')" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in auditorStatusOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" prop="auditStatus">
                  <el-select v-model="detailForm.auditStatus" disabled clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in auditStatusOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="审核资质验证时间" prop="qualificationVerificationDate" :rules="rules.qualificationVerificationDate" class="is-required">
                  <el-date-picker v-model="detailForm.qualificationVerificationDate" type="date" value-format="yyyy-MM-dd" :disabled="isForbidden" clearable placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="$route.query.from === 'edit'">
              <el-col :span="24">
                <el-form-item label="上次修改原因" prop="lastUpdateReason">
                  <el-input v-model="lastUpdateReason" disabled type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="修改原因" prop="updateReason" :rules="rules.updateReason" class="is-required">
                  <el-input v-model="detailForm.updateReason" :disabled="isForbidden" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog title="退回意见" :visible.sync="dialogReturnVisible" width="30%" :close-on-click-modal="false" @close="onClose" class="fpa">
      <el-form ref="returnForm" :model="returnForm" :rules="returnFormRules">
        <el-form-item prop="returnedReason">
          <el-input v-model="returnForm.returnedReason" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center">
        <el-button size="mini" @click="onConfirm" type="primary">确定</el-button>
        <el-button size="mini" @click="onClose">取消</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="Sponsor主数据" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <facilityList v-if="dialogVisible" @selectData="selectData"></facilityList>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import rmcProtAuditorApi from "@/api/rmcProtein/audit";
import facilityList from "../ASL/facilityList.vue";
export default {
  name: "rmcProtAuditDetail",
  components: {
    IcSelect,
    facilityList,
  },
  data() {
    return {
      rmcProteinAuditorId: "",
      ms_roles: null,
      supplierObj: null,
      isDisabled: true,
      isForbidden: false,
      isSponsor: false,
      dialogReturnVisible: false,
      dialogVisible: false,
      isShowSub: null,
      isShowEditSave: null,
      rules: {
        category3Code: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择Category3')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        auditScope: [
          {
            validator: (rule, value, callback) => {
              console.log('value111111', value);
              if (!value || value.length === 0) {
                this.$message.error('请选择审核范围')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        aslGroupCode: [
          {
            validator: (rule, value, callback) => {
              console.log("🚀 ~ file: detail.vue ~ line 200 ~ data ~ this.isSponsor", this.isSponsor)
              console.log('detailForm.auditorType', this.detailForm.auditorType);
              if (!(this.detailForm.auditorType.length === 1 && this.detailForm.auditorType[0] === 'SecondParty')) {
                if (this.isSponsor && !value) {
                  this.$message.error('请选择ASL Group')
                  return callback(new Error(' '));
                };
              }

              callback();
            },
            trigger: "change"
          }
        ],
        auditorName: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入内审员')
                return callback(new Error(' '));
              };
              var reg = /^.{1,100}$/
              if (!reg.test(value)) {
                this.$message.error('字段“内审员”已超出数据库长度要求（长度：100），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        auditorGender: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择性别')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        auditorEducation: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择学历')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        auditorType: [
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                this.$message.error('请选择审核员类型')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        auditorStatus: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择审核员状态')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        qualificationVerificationDate: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择审核资质验证时间')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        auditorMajor: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入专业')
                return callback(new Error(' '));
              };
              var reg = /^.{1,100}$/
              if (!reg.test(value)) {
                this.$message.error('字段“专业”已超出数据库长度要求（长度：100），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        workYear: [
          {
            validator: (rule, value, callback) => {
              if (!value && value !== 0) {
                this.$message.error('请输入从业年限(养殖/食品)')
                return callback(new Error(' '));
              };
              var reg = /^[0-9]\d*$/
              if (!reg.test(value)) {
                this.$message.error('请输入正整数或0')
                return callback(new Error(' '));
              }
              var reg = /^.{1,10}$/
              if (!reg.test(value)) {
                this.$message.error('字段“从业年限(养殖/食品)”已超出数据库长度要求（长度：10），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        updateReason: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入修改原因')
                return callback(new Error(' '));
              };
              var reg = /^.{0,1000}$/
              if (!reg.test(value)) {
                this.$message.error('字段“修改原因”已超出数据库长度要求（长度：1000），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
      },
      detailForm: {
        category3Code: null,
        sponsorName: null,
        auditScope: [],
        aslGroupCode: null,
        auditorName: null,
        auditorGender: null,
        auditorEducation: null,
        auditorMajor: null,
        workYear: null,
        auditorType: [],
        auditorStatus: 'Effective',
        auditStatus: null,
        qualificationVerificationDate: null,
        updateReason: null,
      },
      returnForm: {
        returnedReason: "",
      },
      returnFormRules: {
        returnedReason: [
          { required: true, message: '请输入退回意见', trigger: 'blur' },
        ],
      },
      tableData: [],
      ms_Permission: [],
      category3CodeOptions: [],
      aslGroupCodeOptions: [],
      sexOptions: [],
      educationOptions: [],
      auditorTypeOptions: [],
      auditorStatusOptions: [],
      auditStatusOptions: [],
      rmcProteinAuditorIds: [],
      auditScopeOptions: [],
      lastUpdateReason: "",
      detailInfo: null,

      isMy: true,
    }
  },
  watch: {
  },
  created() {

  },
  mounted() {
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    this.supplierObj = JSON.parse(localStorage.getItem("supplierObj"));
    this.rmcProteinAuditorId = this.$route.query.rmcProteinAuditorId
    if (this.$route.query.from === 'edit') {
      if (this.$route.query.rmcProteinAuditorId) {
        this.rmcProteinAuditorIds.push(this.$route.query.rmcProteinAuditorId)
      }
      this.getDetailInfo()
    } else {
      this.$set(this.detailForm, 'auditStatus', 'Draft')
      this.permissionJudge()
      this.getSponsorByUser()
      this.getAuthorizedCategory3()
    }
    this.getSelection()
  },
  methods: {
    getDetailInfo() {
      rmcProtAuditorApi.getAuditorDetail(this.$route.query.rmcProteinAuditorId).then(res => {
        console.log('获取农场明细', res);
        this.detailForm = res.data
        this.rmcProteinAuditorId = res.data.rmcProteinAuditorId
        this.lastUpdateReason = res.data.updateReason
        this.detailForm.updateReason = ""
        if (res.data.auditScope) {
          this.detailForm.auditScope = res.data.auditScope.split(',')
        }
        if (res.data.auditorType) {
          this.detailForm.auditorType = res.data.auditorType.split(',')
        }
        this.getAslGroupList(res.data.sponsorCode, res.data.aslGroupCode);
        this.permissionJudge()
        this.$nextTick(() => {
          // DOM 更新了
          this.$refs["detailForm"].clearValidate()
        })
      });
    },
    permissionJudge() {
      // CQS用户登录，展示按钮：拥有 RMC_PROT_AUDITOR_APPROVE权限 并且 isCqs=‘Y’
      if (this.$route.query.from === 'edit') {
        if (this.ms_Permission.indexOf('RMC_PROT_AUDITOR_APPROVE') !== -1 && this.$route.query.isCqs === 'Y' && this.detailForm.auditStatus !== 'PendingApproval') {
          this.isShowSub = true
          this.isForbidden = false
        } else if (this.ms_Permission.indexOf('RMC_PROT_AUDITOR_APPROVE') === -1 && this.$route.query.isCqs === 'N' && this.detailForm.auditStatus !== 'PendingApproval') {
          // 供应商用户登录，展示按钮： 没有RMC_PROT_AUDITOR_APPROVE 权限 并且 isCqs='N'
          this.isShowSub = true
          this.isForbidden = false
        } else {
          this.isShowSub = false
          this.isForbidden = true
        }
        // this.$route.query.isCqs === 'N' && (this.ms_Permission.indexOf('RMC_PROT_FARM_SAVE') !== -1 || this.ms_Permission.indexOf('RMC_PROT_FARM_SUBMIT') !== -1)
      } else {
        if (this.detailForm.auditStatus !== 'PendingApproval') {
          this.isShowSub = true
          this.isForbidden = false
        } else {
          this.isShowSub = false
          this.isForbidden = true
        }
      }
      if (this.ms_Permission.indexOf('RMC_PROT_AUDITOR_APPROVE') !== -1) {
        this.isSponsor = false
      } else {
        this.isSponsor = true
      }
      console.log("131231313", this.isSponsor)
      console.log('this.detailForm.auditStatus', this.detailForm.auditStatus);
      if (this.ms_Permission.indexOf('RMC_PROT_AUDITOR_APPROVE') !== -1 && this.$route.query.isCqs === 'Y' && this.rmcProteinAuditorId !== '0' && (!this.detailForm.auditStatus || this.detailForm.auditStatus === 'Draft' || this.detailForm.auditStatus === 'Approved')) {
        this.isShowEditSave = true
      } else if (this.ms_Permission.indexOf('RMC_PROT_AUDITOR_APPROVE') === -1 && this.$route.query.isCqs === 'N' && this.rmcProteinAuditorId !== '0' && (!this.detailForm.auditStatus || this.detailForm.auditStatus === 'Draft')) {
        // 供应商用户登录，展示按钮： 没有RMC_PROT_AUDITOR_APPROVE 权限 并且 isCqs='N'
        this.isShowEditSave = true
      } else {
        this.isShowEditSave = false
      }
      if (this.$route.query.from === 'edit') {
        if(this.supplierObj.supperSupplierCode != this.detailForm.sponsorCode) {
          this.isForbidden = true;
          this.isMy = false;
        }
      }
      console.log("🚀 ~ file: detail.vue ~ line 437 ~ mounted ~ this.isShowEditSave", this.isShowEditSave)
    },
    getSponsorByUser() {
      rmcProtAuditorApi.getSponsorByUser().then(res => {
        console.log('获取Sponsor', res);
        this.detailForm.sponsorName = res.data.supplierName
        this.detailForm.sponsorCode = res.data.supplierCode
        if (this.$route.query.from === 'add') {
          this.getAslGroupList(res.data.supplierCode);
        }
      });
    },
    getAslGroupList(sponsor, aslGroupCode) {
      rmcProtAuditorApi.getAslGroupList(sponsor).then(res => {
        console.log('获取ASL Group', res);
        this.aslGroupCodeOptions = res.data
        var codeLists = res.data.map(ele => {
          return ele.aslGroupCode
        })
        console.log('codeLists', codeLists);
        if (aslGroupCode && !codeLists.includes(aslGroupCode)) {
          this.aslGroupCodeOptions.push({
            aslGroupCode: this.detailForm.aslGroupCode,
            aslGroupName: this.detailForm.aslGroupName,
            enabled: false,
            sponsorCode: sponsor,
          })
        }
        console.log('this.aslGroupCodeOptions', this.aslGroupCodeOptions);
      });
    },
    getAuthorizedCategory3() {
      rmcProtAuditorApi.getAuthorizedCategory3(this.$route.query.rmcProteinAuditorId).then(res => {
        console.log('获取category3', res);
        this.category3CodeOptions = res.data.filter((v) => {
          return v.cascadeKey === 'protein'
        })
        if (this.category3CodeOptions.length === 1) {
          this.detailForm.category3Code = this.category3CodeOptions[0].key
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      });
    },
    getSelection() {
      rmcProtAuditorApi.getSelection(['rmc.RmcCategory3', 'rmc.RmcAuditorAuditScope', 'rmc.RmcAuditorStatus', 'rmc.RmcAuditorType', 'rmc.RmcAuditStatus', 'Education', 'Gender']).then(res => {
        console.log('获取下拉框', res);
        this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
          return v.cascadeKey === 'protein'
        })
        this.auditScopeOptions = res.data['rmc.RmcAuditorAuditScope'];
        this.sexOptions = res.data['Gender'];
        this.educationOptions = res.data['Education'];
        this.auditorTypeOptions = res.data['rmc.RmcAuditorType'];
        this.auditorStatusOptions = res.data['rmc.RmcAuditorStatus'];
        this.auditStatusOptions = res.data['rmc.RmcAuditStatus'];
      });
    },
    onFacility() {
      this.dialogVisible = true
    },
    selectData(data) {
      console.log("获取的数据======", data)
      this.detailInfo = data
      this.$set(this.detailForm, 'sponsorName', data[0].supplierName)
      this.$set(this.detailForm, 'sponsorCode', data[0].supplierCode)
      this.$refs.detailForm.clearValidate('sponsorName');
      this.$set(this.detailForm, 'aslGroupCode', "")
      this.getAslGroupList(data[0].supplierCode)
      this.dialogVisible = false
    },
    onAddSave() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            aslGroupCode: this.detailForm.aslGroupCode,
            auditorName: this.detailForm.auditorName,
            auditScopes: this.detailForm.auditScope,
            auditorGender: this.detailForm.auditorGender,
            auditorEducation: this.detailForm.auditorEducation,
            auditorMajor: this.detailForm.auditorMajor,
            workYear: this.detailForm.workYear,
            auditorTypes: this.detailForm.auditorType,
            auditorStatus: this.detailForm.auditorStatus,
            qualificationVerificationDate: this.detailForm.qualificationVerificationDate,
            updateReason: this.detailForm.updateReason
          }
          rmcProtAuditorApi.addAuditor(obj).then(res => {
            console.log('保存', res);
            if (res.meta.code === 200) {
              this.$message.success('保存成功')
              this.$router.push('/rmcProtAuditor')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onEditSave() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            aslGroupCode: this.detailForm.aslGroupCode,
            auditorName: this.detailForm.auditorName,
            auditScopes: this.detailForm.auditScope,
            auditorGender: this.detailForm.auditorGender,
            auditorEducation: this.detailForm.auditorEducation,
            auditorMajor: this.detailForm.auditorMajor,
            workYear: this.detailForm.workYear,
            auditorTypes: this.detailForm.auditorType,
            auditorStatus: this.detailForm.auditorStatus,
            qualificationVerificationDate: this.detailForm.qualificationVerificationDate,
            updateReason: this.detailForm.updateReason
          }
          rmcProtAuditorApi.updateAuditor(this.rmcProteinAuditorId, obj).then(res => {
            console.log('更新', res);
            if (res.meta.code === 200) {
              this.$message.success('保存成功')
              this.$router.push('/rmcProtAuditor')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onSubmit() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            aslGroupCode: this.detailForm.aslGroupCode,
            auditorName: this.detailForm.auditorName,
            auditScopes: this.detailForm.auditScope,
            auditorGender: this.detailForm.auditorGender,
            auditorEducation: this.detailForm.auditorEducation,
            auditorMajor: this.detailForm.auditorMajor,
            workYear: this.detailForm.workYear,
            auditorTypes: this.detailForm.auditorType,
            auditorStatus: this.detailForm.auditorStatus,
            qualificationVerificationDate: this.detailForm.qualificationVerificationDate,
            updateReason: this.detailForm.updateReason
          }
          rmcProtAuditorApi.submitAuditor(this.rmcProteinAuditorId, obj).then(res => {
            if (res.meta.code === 200) {
              this.$message.success('提交成功')
              this.$router.push('/rmcProtAuditor')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onApprove() {
      rmcProtAuditorApi.approveAuditor({
        rmcProteinAuditorIds: this.rmcProteinAuditorIds
      }).then(res => {
        if (res.meta.code === 200) {
          this.$message.success('批准成功')
          this.$router.push('/rmcProtAuditor')
        } else {
          this.$message.error(res.meta.msg)
        }
      })
    },
    onReturn() {
      this.dialogReturnVisible = true
    },
    onConfirm() {
      this.$refs['returnForm'].validate((valid) => {
        if (valid) {
          rmcProtAuditorApi.returnAuditor({
            rmcProteinAuditorIds: this.rmcProteinAuditorIds,
            returnedReason: this.returnForm.returnedReason
          }).then(res => {
            if (res.meta.code === 200) {
              this.$message.success('退回成功')
              this.onClose()
              this.$router.push('/rmcProtAuditor')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onClose() {
      this.dialogReturnVisible = false
      this.returnForm.returnedReason = ''
    },
    routerBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style>
</style>